import type { SdkType } from './sdk';
import { JS_API_PREFIX } from '../constant';

type SdkErrorData = Record<string, any>;

/**
 * SDK 错误类
 * 用于 Promise rejection，符合 Error 规范的同时携带结构化信息
 */
export class SdkError extends Error {
    public readonly type: SdkType;
    public readonly code: Symbol;
    public readonly data: SdkErrorData;

    constructor(type: SdkType, code: Symbol, message = '', data?: SdkErrorData) {
        super(message || `${JS_API_PREFIX} Error: ${String(code)}`);
        this.name = 'SdkError';
        this.type = type;
        this.code = code;
        this.data = data || {};

        // 保持正确的原型链
        Object.setPrototypeOf(this, SdkError.prototype);
    }

    /**
     * 转换为普通对象格式
     */
    toJSON() {
        return {
            type: this.type,
            code: this.code,
            data: this.data,
            message: this.message
        };
    }
}
